import http from '../http-common';

const get = () => http.get('/weather');

const updateZip = (zipcode) => http.put('/weather', { zipcode });

export const WeatherService = {
  get,
  updateZip,
};
